import { render } from "./Dropdown.vue?vue&type=template&id=5e5d7ca8&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5e5d7ca8"

export default script